(function (angular) {
    'use strict';

    angular
        .module('app')
        .controller('HeaderController', HeaderController);

    /* @ngInject */
    function HeaderController() {
        var vm = this;


    }

})(angular);
